var ButtonVariants;
(function (ButtonVariants) {
    ButtonVariants["Filled"] = "filled";
    ButtonVariants["Outline"] = "outline";
    ButtonVariants["Text"] = "text";
})(ButtonVariants || (ButtonVariants = {}));
var ButtonElementTypes;
(function (ButtonElementTypes) {
    ButtonElementTypes["Button"] = "button";
    ButtonElementTypes["Link"] = "a";
    ButtonElementTypes["Upload"] = "label";
})(ButtonElementTypes || (ButtonElementTypes = {}));

export { ButtonElementTypes, ButtonVariants };
